import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import columns from "./Topics/columns";

import { useTeamTopicContext } from "../../../contexts/TeamTopicContext";

import { Row, Col } from "react-bootstrap";

export default function Topics() {
  const { dispatch, actions, state } = useTeamTopicContext();

  useEffect(() => {
    actions.loadTopics(dispatch, state.team);
  }, []);

  return (
    <>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={state.topics || []}
          noDataComponent={
            <div className="mt20">
              {state.topics == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
